import * as React from "react";
import { quotationFormStyles } from "./QuotationForm.styles";
import { WithStyles, Button } from "@material-ui/core";
import { Beneficiary } from "../../types/Beneficiary";
import QuotationFormBeneficiary from "./QuotationFormBeneficiary";
import AddIcon from "@material-ui/icons/Add";
import { compact } from "lodash";
import { theme } from "../../theme/theme";

interface QuotationFormBeneficiariesProps extends WithStyles<typeof quotationFormStyles> {
    withQuoteParts?: boolean;
    beneficiaries: Beneficiary[];
    onChange(beneficiaries: Beneficiary[]);
}

type QuotationFormBeneficiariesState = {
    
};

class QuotationFormBeneficiaries extends React.Component<QuotationFormBeneficiariesProps, QuotationFormBeneficiariesState> {

    /**
     * 
     * @param beneficiary 
     * @param index 
     */
    public onChange(beneficiary: Beneficiary, index: number) {
        let beneficiaries = this.props.beneficiaries;
        beneficiaries[index] = beneficiary;
        this.props.onChange(beneficiaries);
    }

    /**
     * 
     * @param index 
     */
    public onRemove(index: number) {
        let beneficiaries = this.props.beneficiaries;
        delete beneficiaries[index];    
        this.props.onChange(compact(beneficiaries));
    }

    /**
     * 
     */
    public render() {
        return (
            <>
                {
                    this.props.beneficiaries.map((beneficiary, index) => {
                        return <QuotationFormBeneficiary 
                            withQuoteParts={this.props.withQuoteParts}
                            classes={this.props.classes} 
                            key={index}
                            index={index}
                            beneficiaries={this.props.beneficiaries}
                            onChange={(b) => this.onChange(b, index)} 
                            onRemove={() => this.onRemove(index)}
                        />;
                    })
                }
                {this.props.beneficiaries.length < 3 ?
                    <div>
                        <Button size="small" onClick={this.addBeneficiary.bind(this)} >
                            <AddIcon style={{ marginRight: theme.spacing.unit }} />
                            Ajouter un autre bénéficiaire
                        </Button>
                    </div>
                : null}
            </>
        );
    }

    /**
     * 
     */
    private addBeneficiary() {
        let beneficiaries = this.props.beneficiaries;
        beneficiaries.push({});
        this.props.onChange(beneficiaries);
    }

}

export default QuotationFormBeneficiaries;


// WEBPACK FOOTER //
// ./src/components/QuotationForm/QuotationFormBeneficiaries.tsx